export enum VerificationStateType {
    VERIFIED = 2 
}